module.exports = __webpack_public_path__ + "img/Pharmaceutics & Toxicology.5b43cd18.jpg";